import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { nodeApiClient, nodeApiRoutes } from 'common/services';

type UploadEventAttachmentRequestData = { formData: FormData };
type UploadEventAttachmentRouteParams = { eventId: string };

export const uploadEventAttachment = async ({
  body: { formData },
  routeParams: { eventId },
}: BodyRouteParamsRequest<UploadEventAttachmentRequestData, UploadEventAttachmentRouteParams>) =>
  nodeApiClient.post(nodeApiRoutes.events.attachments.create(eventId), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
